import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import _isNil from 'lodash/isNil'
import _isEmpty from 'lodash/isEmpty'
import { connect as connectStaticText } from '../StaticText/connect'
import { H5 } from '../Heading/index'
import Button, { TYPES } from '../Button/index'

const buildSpeakerName = ({
  honorific, firstName, middleName, lastName,
}) => {
  let speakername = ''
  if (honorific) {
    speakername = `${honorific} `
  }
  speakername += `${firstName} `
  if (middleName) {
    speakername += `${middleName} `
  }
  speakername += `${lastName} `

  return speakername
}

function componentFromHTML (html) {
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: html }} />
}

function SpeakerItem ({ speaker, ctaText }) {
  const {
    bio, headshot, honorific, firstName, middleName, lastName, url,
  } = speaker.toJS()
  const nonBreakingSpace = '\u00a0'
  return (
    <div className="event-item">
      <img
        className="event-item__thumbnail"
        src={headshot || ''}
        alt="thumbnail"
      />
      <div className="event-item__title-speaker">
        <H5 className="event-item__speaker">
          {buildSpeakerName({
            honorific, firstName, middleName, lastName,
          })}
        </H5>
      </div>
      <div className="event-item__long-description">
        {componentFromHTML(bio) || nonBreakingSpace}
      </div>
     {!_isNil(url) && !_isEmpty(url)
     && <div className="event-item__cta">
        <Button
          type={TYPES.PRIMARY}
          url={url}
          scrollToTop
        >
          {ctaText}
        </Button>
      </div>}
    </div>
  )
}

const renderSpeakerList = (speakers, staticText) => {
  const length = _isNil(speakers) ? 0 : speakers.size
  if (length === 0) {
    return null
  }
  return (
    <div className="event-list" >
      <hr />
      <div className="event-items">
        {speakers.map((speaker, index) => {
          return (
            (<SpeakerItem
            key={index}
              speaker={speaker}
              ctaText={ staticText.getIn(['data', 'moreInfo'])}
            />)
          )
        })}
      </div>
    </div >
  )
}

const SpeakerInfo = ({ language, liveAccessEvents, staticText }) => {
  const keynoteSpeakerId = liveAccessEvents.getIn(['eventDetails', language, 'data', 'event', 'keynoteSpeakerId'])
  const speakers = liveAccessEvents.getIn(['eventDetails', language, 'data', 'event', 'speakers']).filter((s) => s.get('id') !== keynoteSpeakerId)
  return (
    renderSpeakerList(speakers, staticText)
  )
}

export default compose(
  connectRedux(
    (state) => {
      return {
        liveAccessEvents: state.liveAccessEvents,
      }
    },
  ),
  connectStaticText({ storeKey: 'eventDetailsPage' }),
)(SpeakerInfo)
